module.exports = __webpack_public_path__ + "static/img/criminal.b39e42e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/criminal.png
// module id = 7AEt
// module chunks = 1 3